import { __assign } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import SvgIcon from "@/components/outter/svg-icon.vue";
import ButtonIcon from "./button-icon.vue";
export default /*@__PURE__*/ _defineComponent(__assign({ name: "MenuToggler" }, { __name: 'menu-toggler', props: {
        collapsed: { type: Boolean },
        arrowIcon: { type: Boolean, default: false },
        zIndex: { default: 98 }
    }, setup: function (__props) {
        var props = __props;
        var icon = computed(function () {
            var icons = {
                0: {
                    0: "line-md:menu-fold-left",
                    1: "line-md:menu-fold-right",
                },
                1: {
                    0: "ph-caret-double-left-bold",
                    1: "ph-caret-double-right-bold",
                },
            };
            var arrowIcon = Number(props.arrowIcon || false);
            var collapsed = Number(props.collapsed || false);
            return icons[arrowIcon][collapsed]; // arrowIcon 为 0 时，为 line-md 图标；为 1 时，为 ph 图标，默认为 line-md，比较好看的折叠
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(ButtonIcon, {
                key: String(_ctx.collapsed),
                "tooltip-content": "菜单折叠",
                "tooltip-placement": "bottom-start",
                "z-index": _ctx.zIndex
            }, {
                default: _withCtx(function () { return [
                    _createVNode(SvgIcon, {
                        class: "svg-icon-size",
                        icon: icon.value
                    }, null, 8, ["icon"])
                ]; }),
                _: 1
            }, 8, ["z-index"]));
        };
    } }));
